<template>
  <v-card>
    <div class="pa-4">
      <div class="d-flex align-center">
        <h4>Messages</h4>
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              outlined
              class="ml-auto"
              tile
              small
              v-bind="attrs"
              v-on="on"
              ><i class="fa-ellipsis-v fa"></i
            ></v-btn>
          </template>

          <v-list>
            <v-list-item>
              <v-list-item-title
                @click="
                  selectedConversation = '';
                  chat_id = '';
                  dialog = true;
                "
              >
                New Chat
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                @click="
                  selectedConversation = '';
                  chat_id = '';
                  newgroupchat = true;
                "
              >
                New Group Chat
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-divider></v-divider>
    <v-container fluid>
      <v-row class="align-center borders">
        <v-col sm="4" cols="12" class="border-right">
          <div class="pa-4">
            <v-text-field
              placeholder="Search Messages"
              dense
              flat
              hide-details
              outlined
            ></v-text-field>
          </div>
        </v-col>
        <v-col sm="8" cols="12" class="d-none d-sm-block">
          <div class="px-4" v-if="selectedConversation != ''">
            <div class="d-flex align-center">
              <div>
                <h4 class="ma-0">{{ selectedConversation.name }}</h4>
                <small>{{ selectedConversation.designation }}</small>
              </div>
              <div class="ml-auto">
                <v-btn
                  @click="lc_createMeeting"
                  class="ml-auto mr-3"
                  icon
                  outlined
                  tile
                  small
                  ><i class="fa fa-video-camera"></i
                ></v-btn>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined tile small v-bind="attrs" v-on="on"
                      ><i class="fa-ellipsis-v fa"></i
                    ></v-btn>
                  </template>
                  <v-list v-if="selectedConversation.type == 'single'">
                    <v-list-item>
                      <v-list-item-title
                        @click="
                          () => {
                            deleteChat({
                              chat_id: selectedConversation.id,
                              user_id: authUser.id,
                            });
                            selectedConversation = '';
                          }
                        "
                        >Delete Chat</v-list-item-title
                      >
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-title
                        @click="
                          () =>
                            disconnect({
                              user1: selectedConversation.participant_id,
                              user2: authUser.id,
                            })
                        "
                        >Block User</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                  <v-list v-if="selectedConversation.type == 'group'">
                    <v-list-item>
                      <v-list-item-title
                        @click="
                          () => {
                            deleteChat({
                              chat_id: selectedConversation.id,
                              user_id: authUser.id,
                            });
                            selectedConversation = '';
                          }
                        "
                        >Delete Chat</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title
                        @click="
                          () => {
                            removeChatMember({
                              chat_id: selectedConversation.id,
                              participant: authUser.id,
                            });
                            selectedConversation = '';
                          }
                        "
                        >Leave Group</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title>
                        <v-dialog v-model="viewmembers" width="500">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on"> View Members </span>
                          </template>
                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              View Members
                            </v-card-title>
                            <div class="pa-4">
                              <div
                                class="chat"
                                v-for="(member,
                                k) of selectedConversation.participants"
                                :key="k"
                              >
                                <v-avatar v-if="member.profile_image" size="42"
                                  ><img :src="member.profile_image"
                                /></v-avatar>
                                <v-avatar v-else size="42"></v-avatar>
                                <span class="ml-3">{{ member.name }}</span>
                                <v-btn
                                  @click="
                                    () => {
                                      removeChatMember({
                                        chat_id: selectedConversation.id,
                                        participant: member.id,
                                      });
                                      selectedConversation = '';
                                    }
                                  "
                                  v-if="
                                    selectedConversation.owner_id ==
                                      authUser.id &&
                                      selectedConversation.owner_id != member.id
                                  "
                                  color="primary"
                                  class="ml-auto"
                                  small
                                  >Remove</v-btn
                                >
                              </div>
                            </div>
                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                text
                                @click="viewmembers = false"
                              >
                                Cancel
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col sm="4" cols="12" class="border-right d-none d-sm-block">
          <div class="conversations">
            <div v-if="chats.length != 0">
              <div v-for="conversation in chats" v-bind:key="conversation.id">
                <div
                  class="chat"
                  @click="
                    () => {
                      updateSelected(conversation);
                      getChat(conversation.id);
                    }
                  "
                  v-bind:class="{
                    active: selectedConversation.id == conversation.id,
                  }"
                >
                  <v-avatar v-if="conversation.profile_image" class="mr-2"
                    ><img :src="conversation.profile_image"
                  /></v-avatar>
                  <v-avatar v-else class="mr-2"
                    ><img src="/images/default-profile.jpg"
                  /></v-avatar>
                  <span class="ml-3">{{ conversation.name }}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <v-btn
                block
                @click="
                  selectedConversation = '';
                  chat_id = '';
                  dialog = true;
                "
                >New Conversation</v-btn
              >
              <v-btn
                block
                class="mt-3"
                @click="
                  selectedConversation = '';
                  chat_id = '';
                  newgroupchat = true;
                "
                >Group Conversation</v-btn
              >
            </div>
          </div>
        </v-col>
        <v-col
          sm="8"
          v-if="selectedConversation != ''"
          cols="12 d-none d-sm-block"
        >
          <div class="chat-box-container" id="chat-box-container">
            <div
              v-if="chatLoading"
              class="d-flex align-items-center justify-center py-5"
            >
              <v-progress-circular indeterminate size="20" color="grey" />
            </div>
            <div
              v-else
              class="px-4"
              v-for="(message, k) in chat"
              v-bind:key="k"
            >
              <div
                class="d-flex"
                v-bind:class="{ 'chat-right': message.sender == authUser.id }"
              >
                <div class="chat-box">
                  <div>
                    <small
                      class="d-block font-weight-bold"
                      v-if="
                        selectedConversation.type == 'group' &&
                          message.sender != authUser.id
                      "
                      >{{ message.name }}</small
                    >

                    <span
                      v-if="message.isMeeting == false"
                      class="mr-6 grey--text text--darken-2"
                      >{{ message.message }}</span
                    >
                    <span v-else>
                      <a
                        :href="message.message + '&user=' + authUser.username"
                        target="_blank"
                        >Join Meeting</a
                      >
                    </span>
                    <span
                      v-if="message.attachment"
                      class="d-block attachment grey--text text--darken-2"
                    >
                      <div
                        class="attachment-image"
                        v-if="message.attachment.type == 'image'"
                      >
                        <a :href="message.attachment.url" target="_blank">
                          <img :src="message.attachment.url" />
                        </a>
                      </div>
                      <div v-else-if="message.attachment.type == 'video'">
                        <iframe :src="message.attachment.url" />
                      </div>
                      <div v-else-if="message.attachment.type == 'audio'">
                        <audio controls>
                          <source :src="message.attachment.url" />
                        </audio>
                      </div>
                      <div v-else>
                        <a :href="message.attachment.url" target="_blank"
                          >View Attachment</a
                        >
                      </div>
                    </span>
                  </div>
                  <!-- <time class="ml-auto"
                    ><small>{{ conversation.time }}</small></time
                  > -->
                </div>
              </div>
            </div>
          </div>
          <v-form v-if="!chatLoading" @submit="send_message" ref="ref_form1">
            <div
              v-if="
                authUser.connects.includes(
                  selectedConversation.participant_id
                ) || selectedConversation.type == 'group'
              "
            >
              <v-textarea
                flat
                dense
                rows="3"
                placeholder="Write Message"
                outlined
                v-model="message"
                :rules="[myrules.required]"
              />
              <div class="d-flex mt-3">
                <input
                  type="file"
                  @change="(e) => (this.file = e.target.files[0])"
                  ref="ref_attachment"
                  class="d-none"
                />
                <v-btn
                  @click="(e) => $refs.ref_attachment.click()"
                  icon
                  outlined
                  tile
                  small
                  ><i class="fa fa-paperclip"></i
                ></v-btn>
                <!-- <v-btn class="ml-3" icon outlined tile small
                ><i class="fa fa-music"></i
              ></v-btn> -->
                <v-btn
                  type="submit"
                  class="ml-3"
                  color="primary"
                  icon
                  outlined
                  tile
                  small
                  ><i class="fa fa-paper-plane"></i
                ></v-btn>
              </div>

              <small>{{ this.file.name }}</small>
            </div>
            <div
              v-else
              style="height: 100%"
              class="pt-4 d-flex align-center justify-center"
            >
              <h4>You are no more connected with this person</h4>
            </div>
          </v-form>
        </v-col>
        <v-col sm="8" v-else cols="12 d-none d-sm-block">
          <div style="text-align: center" class="mt-16">
            No Conversation Yet
          </div>
        </v-col>
      </v-row>
      <div class="mt-4 d-block d-sm-none">
        <div
          class="conversations"
          v-bind:class="{ 'd-none': selectedConversation != '' }"
        >
          <div v-for="conversation in chats" v-bind:key="conversation.id">
            <div
              class="chat"
              @click="
                () => {
                  updateSelected(conversation);
                  getChat(conversation.id);
                }
              "
              v-bind:class="{
                active: selectedConversation.id == conversation.id,
              }"
            >
              <v-avatar v-if="conversation.profile_image" class="mr-2"
                ><img :src="conversation.profile_image"
              /></v-avatar>
              <v-avatar v-else class="mr-2"
                ><img src="/images/default-profile.jpg"
              /></v-avatar>
              <span class="ml-3">{{ conversation.name }}</span>
            </div>
          </div>
        </div>
        <div class="px-4 py-3" v-if="selectedConversation != ''">
          <div class="d-flex align-center">
            <v-btn
              icon
              outlined
              tile
              small
              class="mr-2"
              @click="selectedConversation = ''"
              ><i class="fa fa-angle-left"></i
            ></v-btn>
            <div>
              <h4 class="ma-0">{{ selectedConversation.name }}</h4>
              <!-- <small>{{ selectedConversation.designation }}</small> -->
            </div>
            <div class="ml-auto">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon outlined tile small v-bind="attrs" v-on="on"
                    ><i class="fa-ellipsis-v fa"></i
                  ></v-btn>
                </template>
                <v-list v-if="selectedConversation.type == 'single'">
                  <v-list-item>
                    <v-list-item-title
                      @click="
                        () => {
                          deleteChat({
                            chat_id: selectedConversation.id,
                            user_id: authUser.id,
                          });
                          selectedConversation = '';
                        }
                      "
                      >Delete Chat</v-list-item-title
                    >
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-title
                      @click="
                        () =>
                          disconnect({
                            user1: selectedConversation.participant_id,
                            user2: authUser.id,
                          })
                      "
                      >Block User</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
                <v-list v-if="selectedConversation.type == 'group'">
                  <v-list-item>
                    <v-list-item-title
                      @click="
                        () => {
                          deleteChat({
                            chat_id: selectedConversation.id,
                            user_id: authUser.id,
                          });
                          selectedConversation = '';
                        }
                      "
                      >Delete Chat</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Leave Group</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-dialog v-model="viewmembers" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on"> View Members </span>
                        </template>
                        <v-card>
                          <v-card-title class="text-h5 grey lighten-2">
                            View Members
                          </v-card-title>
                          <div class="pa-4">
                            <div
                              class="chat"
                              v-for="(member,
                              k) of selectedConversation.participants"
                              :key="k"
                            >
                              <v-avatar v-if="member.profile_image" size="42"
                                ><img :src="member.profile_image"
                              /></v-avatar>
                              <v-avatar v-else size="42"
                                ><img src="/images/default-profile.jpg"
                              /></v-avatar>
                              <span class="ml-3">{{ member.name }}</span>
                              <v-btn color="primary" class="ml-auto" small
                                >Remove</v-btn
                              >
                            </div>
                          </div>
                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              text
                              @click="viewmembers = false"
                            >
                              Cancel
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
        <div class="border-top"></div>
      </div>
      <div class="d-sm-none">
        <div
          class="chat-box-container"
          v-bind:class="{ 'd-none': selectedConversation == '' }"
        >
          <div
            v-if="chatLoading"
            class="d-flex align-items-center justify-center py-5"
          >
            <v-progress-circular indeterminate size="20" color="grey" />
          </div>
          <div v-else class="pa-4" v-for="(message, k) in chat" v-bind:key="k">
            <div
              class="d-flex"
              v-bind:class="{ 'chat-right': message.sender == authUser.id }"
            >
              <div class="chat-box">
                <div>
                  <small
                    class="d-block font-weight-bold"
                    v-if="
                      selectedConversation.type == 'group' &&
                        message.sender != authUser.id
                    "
                    >{{ message.name }}</small
                  >

                  <span
                    v-if="message.isMeeting == false"
                    class="mr-6 grey--text text--darken-2"
                    >{{ message.message }}</span
                  >
                  <span v-else>
                    <a
                      :href="message.message + '&user=' + authUser.username"
                      target="_blank"
                      >Join Meeting</a
                    >
                  </span>
                  <span
                    v-if="message.attachment"
                    class="d-block attachment grey--text text--darken-2"
                  >
                    <div
                      class="attachment-image"
                      v-if="message.attachment.type == 'image'"
                    >
                      <a :href="message.attachment.url" target="_blank">
                        <img :src="message.attachment.url" />
                      </a>
                    </div>
                    <div v-else-if="message.attachment.type == 'video'">
                      <iframe :src="message.attachment.url" />
                    </div>
                    <div v-else-if="message.attachment.type == 'audio'">
                      <audio controls>
                        <source :src="message.attachment.url" />
                      </audio>
                    </div>
                    <div v-else>
                      <a :href="message.attachment.url" target="_blank"
                        >View Attachment</a
                      >
                    </div>
                  </span>
                </div>
                <!-- <time class="ml-auto"
                    ><small>{{ conversation.time }}</small></time
                  > -->
              </div>
            </div>
          </div>
        </div>
        <v-form v-if="!chatLoading" @submit="send_message" ref="ref_form2">
          <div
            v-if="
              authUser.connects.includes(selectedConversation.participant_id) ||
                selectedConversation.type == 'group'
            "
          >
            <v-textarea
              flat
              dense
              rows="3"
              placeholder="Write Message"
              outlined
              v-model="message"
              :rules="[myrules.required]"
            />
            <div class="d-flex mt-3">
              <input
                type="file"
                @change="(e) => (this.file = e.target.files[0])"
                ref="ref_attachment"
                class="d-none"
              />
              <v-btn
                @click="(e) => $refs.ref_attachment.click()"
                icon
                outlined
                tile
                small
                ><i class="fa fa-paperclip"></i
              ></v-btn>
              <!-- <v-btn class="ml-3" icon outlined tile small
                ><i class="fa fa-music"></i
              ></v-btn> -->
              <v-btn
                type="submit"
                class="ml-3"
                color="primary"
                icon
                outlined
                tile
                small
                ><i class="fa fa-paper-plane"></i
              ></v-btn>
            </div>

            <small>{{ this.file.name }}</small>
          </div>
          <div
            v-else
            style="height: 100%"
            class="pt-4 d-flex align-center justify-center"
          >
            <h4>You are no more connected with this person</h4>
          </div>
        </v-form>
      </div>
    </v-container>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> New Chat </v-card-title>
        <div class="pa-4">
          <v-autocomplete
            v-if="!$router.currentRoute.query.user"
            v-model="user"
            :items="this.userConnects"
            item-text="name"
            item-value="id"
            outlined
            dense
            label="Select User"
          ></v-autocomplete>
          <v-textarea
            outlined
            dense
            label="Message"
            v-model="message"
          ></v-textarea>
        </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="send_message">
            Start Conversation
          </v-btn>
          <v-btn color="primary" text @click="dialog = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newgroupchat" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          New Group Chat
        </v-card-title>
        <v-form
          @submit="
            (e) => {
              this.isGroup = true;
              send_message(e);
            }
          "
          ref="ref_form3"
        >
          <div class="pa-4">
            <v-text-field outlined dense label="Name" v-model="title" />
            <v-autocomplete
              v-model="members"
              :items="this.userConnects"
              item-text="name"
              item-value="id"
              outlined
              dense
              label="Select Users"
              multiple
            ></v-autocomplete>
            <v-textarea
              outlined
              dense
              label="Message"
              v-model="message"
            ></v-textarea>
          </div>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text type="submit"> Create Group </v-btn>
            <v-btn color="primary" text @click="newgroupchat = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { baseDomain } from '../variables';
export default {
  name: "Messages",
  updated() {
    let element = document.getElementById("chat-box-container");
    if (element) {
      element.scrollTo(0, element.scrollHeight);
    }
  },
  data() {
    return {
      dialog: false,
      file: "",
      title: "",
      chat_id: "",
      isGroup: false,
      newgroupchat: false,
      viewmembers: false,
      selectedConversation: "",
      message: "",
      user: "",
      members: "",
    };
  },
  mounted() {
    let id = this.authUser && this.authUser.id;
    
    this.getChats(id);
    let { user } = this.$router.currentRoute.query;
    if (user != undefined) {
      this.dialog = true;
      this.user = user;
    }
  },
  watch: {
    chats() {
      if (this.selectedConversation != "") {
        for (let chat of this.chats) {
          if (chat.id == this.selectedConversation.id) {
            this.selectedConversation = chat;
          }
        }
      }
    },
  },
  methods: {
    async send_message(e, message = this.message, isMeeting = false) {
      e.preventDefault();
      let obj = {
        message: message,
        sender: this.authUser.id,
        isMeeting,
        type: this.isGroup ? "group" : "single",
        reciever:
          this.user == ""
            ? this.members.length > 0
              ? this.members
              : [this.user]
            : [this.user],
        isURLChat: this.isURLChat(),
        isAlreadyChat:
          this.isAlreadyChat(this.user) || this.chat_id ? true : false,
      };

      if (this.isAlreadyChat(this.user) || this.chat_id != "") {
        if (this.selectedConversation.id) {
          obj["chat_id"] = this.selectedConversation.id;
        } else {
          obj["chat_id"] = this.isAlreadyChat(this.user).id;
        }
      }
      if (this.isGroup) {
        obj["name"] = this.title;
        obj["owner_id"] = this.authUser.id;
      }
      if (this.file != "") obj["attachment"] = this.file;
      
      await this.sendMessage(obj);
      this.dialog = false;
      this.title = "";
      this.newgroupchat = false;
      this.isGroup = false;
      this.file = "";
      this.user = "";
      this.message = "";
      if (this.$refs.ref_form1) {
        this.$refs.ref_form1.reset();
      }
      if (this.$refs.ref_form2) {
        this.$refs.ref_form2.reset();
      }
      if (this.$refs.ref_form3) {
        this.$refs.ref_form3.reset();
      }
      if (this.isURLChat()) {
        this.$router.push("/messages");
      }
    },
    async lc_createMeeting(e) {
      this.$store.commit("setChatLoading", true);
      try {
        const token = await fetch(
          "https://zoom-token-generator.herokuapp.com/userinfo",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: "ghulam_mustafa@nextpak.org" }),
          }
        );
        const tokenData = await token.json();
        
        const response = await fetch(
          `${baseDomain}/createMeeting`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token: tokenData.token }),
          }
        );
        const data = await response.json();
        let link = `https://lyricster-meetings.web.app/join?meetingId=${data.meeting_id}&pwd=${data.password}`;
        this.send_message(e, link, true);
      } catch (err) {
        console.log(err.response);
      } finally {
        this.$store.commit("setChatLoading", false);
      }
    },
    isURLChat() {
      let { user } = this.$router.currentRoute.query;
      return user != undefined;
    },
    updateSelected(conversation) {
      
      this.selectedConversation = conversation;
      this.chat_id = conversation.id;
    },
    isAlreadyChat(user) {
      let obj = this.chats.find(
        (chat) => chat.participants.includes(user) && chat.type == "single"
      );
      return obj ? obj : false;
    },
  },
};
</script>

<style scoped>
.attachment {
  min-width: 280px;
}
.attachment img,
.attachment audio,
.attachment iframe {
  max-width: 280px;
  margin-top: 10px;
}
.chat-box-container {
  height: 320px;
  overflow-y: auto;
}
.conversations {
  height: 450px;
  overflow-y: auto;
}
.border-top {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.chat {
  height: 50px;
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
}
.chat-right {
  justify-content: flex-end;
}
.chat:hover,
.chat.active {
  background-color: rgba(0, 0, 0, 0.2);
}
.chat-box {
  padding: 5px 20px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  max-width: 80%;
  width: auto;
  display: flex;
  margin-bottom: 10px;
}
.borders {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
